/**
 * Parse API trade-success copy into MT5 Done-page fields.
 * Example: "Trade has been successfully executed. 10101011 - ZINC 300ct2026 SELL 1@420.75"
 */

export function looksLikeTradeSuccess(message) {
  const text = message != null ? String(message) : "";
  if (!text.trim()) return false;
  if (/successfully\s+(executed|placed)/i.test(text)) return true;
  if (/successfully/i.test(text) && /\b(BUY|SELL)\b/i.test(text)) return true;
  return false;
}

/** API / validation failures such as "Market is Closed" must not open the Done page. */
export function looksLikeTradeFailure(message) {
  const text = message != null ? String(message).replace(/\s+/g, " ").trim() : "";
  if (!text) return false;
  if (looksLikeTradeSuccess(text)) return false;
  return /market\s+is\s+closed|has been closed|market closed|not allowed|blocked|banned|insufficient|rejected|fail|cannot|can't|could not|expired|wrong quote|view permission|margin|try again|technical error/i.test(
    text
  );
}

export function isTradeSuccessToastMessage(message, varient) {
  const text = message != null ? String(message) : "";
  if (looksLikeTradeFailure(text)) return false;
  if (varient === "successOrder") return true;
  if (!text.trim()) return false;
  if (/successfully\s+executed/i.test(text)) return true;
  if (/\b(BUY|SELL)\b/i.test(text) && /@\s*\d/.test(text) && /\d+\s*-/.test(text)) {
    return true;
  }
  return false;
}

/**
 * @returns {{
 *   ticket: string|null,
 *   symbol: string|null,
 *   side: 'buy'|'sell'|null,
 *   qty: string|null,
 *   price: string|null,
 *   raw: string,
 * }}
 */
export function parseTradeSuccessMessage(raw) {
  const text = raw != null ? String(raw).replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim() : "";
  const m = text.match(
    /(\d+)\s*-\s*(.+?)\s+(BUY|SELL)\s+(\d+(?:\.\d+)?)\s*@\s*(\d+(?:\.\d+)?)/i
  );
  if (m) {
    return {
      ticket: m[1],
      symbol: m[2].trim(),
      side: m[3].toLowerCase() === "sell" ? "sell" : "buy",
      qty: m[4],
      price: m[5],
      raw: text,
    };
  }
  return {
    ticket: null,
    symbol: null,
    side: null,
    qty: null,
    price: null,
    raw: text,
  };
}
